import styled from 'styled-components'
import { Flex } from 'components'

export const Login = styled(Flex)``
